import React from "react";
import { Box } from "@mui/material";
import { BodyContainer, Header, HeaderBtn, HeaderTitle } from "../bank/styles";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

function PaymentDetails() {
  return (
    <Box>
      <Header>
        <HeaderTitle>Payment Details</HeaderTitle>
        <Box sx={{ display: "flex", gap: "8px", justifyContent: "flex-end" }}>
          <HeaderBtn variant="contained">
            <ArrowCircleLeftIcon sx={{ mr: "8px" }} /> Back
          </HeaderBtn>
          <HeaderBtn variant="contained">
            <PictureAsPdfIcon sx={{ mr: "8px" }} /> PDF
          </HeaderBtn>
          <HeaderBtn variant="contained">
            <PrintIcon sx={{ mr: "8px" }} /> Print
          </HeaderBtn>
        </Box>
      </Header>
      <BodyContainer></BodyContainer>
    </Box>
  );
}

export default PaymentDetails;
